import { call } from "redux-saga/effects";
import { ACTIONS, API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";
import { ActionExtended } from "../_common/interfaces/ActionExtended";

const sagaFn = sagaFunction as unknown as (...args: unknown[]) => Generator;

export function* getEventList(action: ActionExtended): Generator {
  const yieldPuts = [
    { type: ACTIONS.EVENT.GET_EVENT_LIST },
    // {type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED},
  ];
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.GET_EVENT_LIST, action.payload, false, yieldPuts);
}

export function* getEventGameList(action: ActionExtended): Generator {
  const yieldPuts = [
    { type: ACTIONS.EVENT.GET_EVENT_GAME, payload: "tasks" },
    { type: ACTIONS.EVENT.GET_STATUS_MESSAGE, payload: "status" },
    { type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED, payload: "rodeo_event_dtls.login_required" },
    { type: ACTIONS.EVENT.SITE_HEADER, payload: "rodeo_event_game_info.enable_header" },
  ];
  yield call(sagaFn, action, CallApi.POST, API_URL.EVENT.GET_EVENT_GAME, action.payload, true, yieldPuts);
}

export function* performanceList(action: ActionExtended): Generator {
  const yieldPuts = [
    // { type: ACTIONS.EVENT.GET_EVENT_GAME, payload: "event_dtls" },
    { type: ACTIONS.EVENT.GET_STATUS_MESSAGE, payload: "status" },
    { type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED, payload: "rodeo_event_dtls.login_required" },
    { type: ACTIONS.EVENT.SITE_HEADER, payload: "rodeo_event_game_info.enable_header" },
    { type: ACTIONS.EVENT.PERFORMANCE_LIST, payload: "performances" },
  ];
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.PERFORMANCE_LIST, action.payload, true, yieldPuts);
}

export function* getEventGameDetails(action: ActionExtended): Generator {
  const yieldPuts = [
    { type: ACTIONS.EVENT.GET_EVENT_GAME_DETAILS },
    { type: ACTIONS.EVENT.GET_STATUS_MESSAGE, payload: "status" },
    { type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED, payload: "rodeo_event_dtls.login_required" },
    { type: ACTIONS.EVENT.SITE_HEADER, payload: "rodeo_event_game_info.enable_header" },
  ];
  yield call(sagaFn, action, CallApi.POST, API_URL.EVENT.GET_EVENT_GAME_DETAILS, action.payload, true, yieldPuts);
}

export function* getUpcomingEventList(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.POST, API_URL.EVENT.GET_UPCOMING_EVENT, action.payload, false);
}

export function* joinEventGame(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.POST, API_URL.EVENT.JOIN_EVENT_GAME, action.payload, true);
}

export function* pickRider(action: ActionExtended): Generator {
  const yieldPuts = [{ type: ACTIONS.EVENT.SET_PICK_ID, payload: "id" }, { type: ACTIONS.EVENT.SET_EVENT_IS_PICKED }];
  yield call(sagaFn, action, CallApi.POST, API_URL.EVENT.PICK_RIDER, action.payload, true, yieldPuts);
}

export function* viewLeaderBoard(action: ActionExtended): Generator {
  const yieldPuts = [{ type: ACTIONS.EVENT.LEADERBOARD }];
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.LEADERBOARD, action.payload, true, yieldPuts);
}

export function* tvImageDetails(action: ActionExtended): Generator {
  const yieldPuts = [{ type: ACTIONS.TV_IMAGE.DETAILS }];
  yield call(sagaFn, action, CallApi.GET, API_URL.TV_IMAGE.DETAILS, action.payload, false, yieldPuts);
}

export function* saveVote(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.POST, API_URL.EVENT.SAVE_VOTE, action.payload, true);
}

export function* getGameDetails(action: ActionExtended): Generator {
  const yieldPuts = [{ type: ACTIONS.EVENT.GET_GAME_DETAILS }];
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.GET_GAME_DETAILS, action.payload, true, yieldPuts);
}

export function* getPrizeDetails(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.PRIZE, action.payload, true);
}

export function* getRodeoEventGeoLocations(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.GET_RODEO_EVENT_GEO_LOCATIONS, action.payload, true);
}

export function* getLeaderboardLocationList(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.LEADERBOARD_LOCATION_LIST, action.payload, true);
}

export function* winningTicketResults(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.WINNING_TICKET_RESULTS, action.payload, true);
}

export function* mostPopularPicks(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.POST, API_URL.EVENT.MOST_POPULAR_PICKS, action.payload, true);
}

export function* getMyTeam(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.GET_MY_TEAM, action.payload, true);
}

export function* getShareImageLink(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.POST, API_URL.EVENT.SHARE_IMAGE_LINK, action.payload, true);
}

export function* yourPicks(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.GET, API_URL.EVENT.YOUR_PICKS, action.payload, true);
}

export function* getGameStatusText(action: ActionExtended): Generator {
  const data = action.payload;
  const yieldPuts = [{ type: ACTIONS.EVENT.GET_IR_STATUS_MESSAGE }];
  yield call(
    sagaFn,
    action,
    CallApi.GET,
    API_URL.EVENT.GET_GAME_STATUS_TEXT + (data?.game_id ? "/" + data?.game_id : ""),
    null,
    false,
    yieldPuts
  );
}

export function* scanQRCode(action: ActionExtended): Generator {
  yield call(sagaFn, action, CallApi.POST, API_URL.EVENT.SCAN_QR_CODE, action.payload, true);
}
